import { pagesConfig } from '../../shared/pages-config';
import { Navigate } from 'react-router-dom';

export default function InsightsPage() {
  return <Navigate to={pagesConfig.insightsCloudInsights.link} replace />;
}
